import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const TermsOfService = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-stone-50 flex flex-col">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} isHomePage={false} />
      
      <main className="flex-grow pt-28 pb-20">
        <div className="max-w-4xl mx-auto px-6 bg-white p-10 md:p-16 rounded-3xl shadow-sm border border-blue-100">
          <h1 className="text-3xl md:text-5xl font-bold text-blue-900 mb-8 font-serif">Terms of Service</h1>
          
          <div className="prose prose-blue max-w-none text-stone-600 space-y-6">
            <p>
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
            
            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">1. Acceptance of Terms</h2>
              <p>
                By accessing and using the website of Sky's PhysioRehab & Slimming Centre ("us", "we", or "our"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by these terms, please do not use this site.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">2. Medical Disclaimer</h2>
              <p className="font-semibold text-blue-900">Not Medical Advice</p>
              <p>
                The information provided on this website is for educational and informational purposes only and does not constitute medical advice, diagnosis, or treatment. It is not a substitute for professional medical advice from a qualified healthcare provider.
              </p>
              <p className="mt-2 font-semibold text-blue-900">No Doctor-Patient Relationship</p>
              <p>
                Your use of this website or communication with us through the booking forms, WhatsApp, or email does not create a doctor-patient relationship. Such a relationship is only established after a formal in-person consultation and clinical assessment.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">3. Bookings and Consultations</h2>
              <p>
                Submitting a booking request through our website does not guarantee an immediate appointment. Our team will contact you to confirm availability. We reserve the right to refuse service or cancel appointments as necessary.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">4. Intellectual Property</h2>
              <p>
                All content, organization, graphics, design, compilation, and other matters related to the Site are protected under applicable copyrights and trademarks. The copying, redistribution, use, or publication by you of any such matters or any part of the Site is strictly prohibited without our express written permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">5. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by applicable law, Sky's PhysioRehab & Slimming Centre shall not be liable for any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the website; (ii) any conduct or content of any third party on the website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">6. Governing Law</h2>
              <p>
                These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions. Any dispute arising from these terms will be subject to the exclusive jurisdiction of the courts located in Lucknow, Uttar Pradesh.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;
